var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2393 20.2754C10.7065 20.7422 11.3401 21.0042 12.0006 21.0037C12.6611 21.004 13.2947 20.7417 13.7619 20.2747C14.2291 19.8077 14.4916 19.1742 14.4916 18.5137V18.0024",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 2.24658C8.2711 2.24658 5.2479 5.26978 5.2479 8.99908V12.7379L4.1032 13.8818L4.10244 13.8826C3.55527 14.4309 3.24769 15.1737 3.24707 15.9484L3.99707 15.949H3.24707C3.24707 16.6926 3.54248 17.4058 4.0683 17.9316C4.59413 18.4574 5.3073 18.7528 6.05093 18.7528H6.18647L7.68647 17.2528H6.05093C5.70512 17.2528 5.37348 17.1155 5.12896 16.8709C4.88451 16.6265 4.74715 16.295 4.74707 15.9493L8.98994 15.9494L8.98997 15.9493L4.74707 15.9493C4.74745 15.5717 4.89739 15.2096 5.16408 14.9423L5.16423 14.9421L6.52804 13.5793C6.66881 13.4386 6.7479 13.2478 6.7479 13.0488V8.99908C6.7479 6.09821 9.09953 3.74658 12.0004 3.74658C14.4957 3.74658 16.5845 5.48656 17.1199 7.8194L18.3212 6.61813C17.3585 4.06367 14.8916 2.24658 12.0004 2.24658ZM18.7529 9.01483L17.2529 10.5148V13.0488C17.2529 13.2478 17.332 13.4386 17.4728 13.5793L18.8366 14.9421L18.8368 14.9423C19.1035 15.2097 19.2534 15.5718 19.2537 15.9495L11.8184 15.9494L11.8183 15.9494L19.2537 15.9496C19.2534 16.6694 18.6698 17.2528 17.9499 17.2528H10.5149L9.0149 18.7528H17.9499C19.4984 18.7528 20.7537 17.4975 20.7537 15.949H20.0037L20.7537 15.9484C20.7531 15.1737 20.4455 14.4309 19.8984 13.8826L19.8976 13.8818L18.7529 12.7379V9.01483Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3535 3.35352L3.35352 21.3535",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifOff);
export default __webpack_public_path__ + "static/media/notifOff.741197b8bdfc074723ffd12d98f67def.svg";
export { ForwardRef as ReactComponent };